// @ts-nocheck
import { capitalize } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';
import { Formatters } from 'sonata-static-storage/lib/helpers/generalFormatters.helpers';

import { DataFeesTooltipStyled } from './dataFeesTooltip.style';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

type Props = {
  campaigns: {
    dataFees: string[];
    feesBySolution: boolean;
    name: string;
    userDataFees: {
      concept: string;
      copy: string;
      fee: number;
    }[];
  }[];
  currencyInfo: BaseCurrencyInterface;
  id: string;
};

function DataFeesTooltip({ campaigns, currencyInfo, id }: Props) {
  const { formatMessage } = useIntl();
  const getDataFees = () =>
    campaigns.map(({ dataFees, feesBySolution, name, userDataFees }, campaignIndex) => {
      const transformedDataFees = feesBySolution
        ? userDataFees.map(userDataFeeBySolution => ({
            concept: userDataFeeBySolution.copy,
            cost: Formatters.currency(userDataFeeBySolution.fee * 1000, currencyInfo)
          }))
        : dataFees.map(dataFee => {
            const associatedDataFee = userDataFees.find(
              sectionEntry => sectionEntry.concept === dataFee && sectionEntry.fee > 0
            );
            const dataFeeFee = associatedDataFee ? associatedDataFee.fee : 0;
            return {
              concept: associatedDataFee?.copy || capitalize(dataFee),
              cost: Formatters.currency(dataFeeFee * 1000, currencyInfo)
            };
          });

      return (
        <div className="dataFeesTooltip__campaign" key={[id, campaignIndex].join('_')}>
          <div className="dataFeesTooltip__campaignName">{name}</div>
          {transformedDataFees?.length ? (
            transformedDataFees.map(({ concept, cost }, campaignDataFeeIdenx) => (
              <div
                className="dataFeesTooltip__campaignDataFee"
                key={[id, campaignIndex, campaignDataFeeIdenx].join('_')}
              >
                <span className="dataFeesTooltip__campaignDataFeeConcept">{concept}</span>
                <span className="dataFeesTooltip__campaignDataFeeCost">{cost}</span>
              </div>
            ))
          ) : (
            <div className="dataFeesTooltip__campaignEmptyState">
              {formatMessage({
                defaultMessage: 'No Data Fees associated',
                id: 'statsTable.dataFeesTooltip.emptyLabel'
              })}
            </div>
          )}
        </div>
      );
    });

  return (
    <DataFeesTooltipStyled className="dataFeesTooltip" id={id}>
      <div className="dataFeesTooltip__header">
        {formatMessage({
          defaultMessage: 'Associated Data Fees (CPM)',
          id: 'statsTable.dataFeesTooltip.title'
        })}
      </div>
      {getDataFees()}
    </DataFeesTooltipStyled>
  );
}

DataFeesTooltip.displayName = 'DataFeeTooltip';
export default DataFeesTooltip;
